export type SvgNameType = "AgentAdvisor" | 
"AgentCompare" | 
"AgentFee" | 
"AgentFund" | 
"AgentHome" | 
"AgentPortfolio" | 
"AgentRanking" | 
"AgentSkill" | 
"Amex" | 
"Apple" | 
"arrow-top-right" | 
"ask" | 
"askEd" | 
"aura_solid" | 
"bank" | 
"BinanceBadge" | 
"BinanceUsdBadge" | 
"BitcoinBadge" | 
"bnb-member" | 
"Campaign" | 
"car" | 
"ChainlinkBadge" | 
"check-contained" | 
"Coinbase" | 
"coverage-radar-light" | 
"coverage-radar" | 
"dai" | 
"Diners Club" | 
"Discord" | 
"Discover" | 
"dollar-bag" | 
"dot" | 
"Earlybird" | 
"edgen-feed" | 
"empty-feed" | 
"empty-result" | 
"error-circle-portfolio-notice" | 
"error-circle-portfolio" | 
"error" | 
"eth-w" | 
"eth" | 
"EthereumBadge" | 
"film" | 
"flag" | 
"Gas" | 
"GasBnb" | 
"GasDapp" | 
"goal-16-portfolio" | 
"Google pay" | 
"Google with colour" | 
"gravity-ui_signal" | 
"growUp" | 
"heart" | 
"hot-outline" | 
"ic_base" | 
"ic_loading" | 
"ic_loading2" | 
"icon-first-read" | 
"icon-goallive" | 
"Instagram" | 
"JCB" | 
"leaderboard" | 
"manage" | 
"Mastercard" | 
"matic" | 
"member-01" | 
"member-02-b" | 
"member-02-o" | 
"member-03-b" | 
"member-03-p" | 
"member-04-b" | 
"member-04-p" | 
"member" | 
"Metamask" | 
"MetaMaskBadge" | 
"minus" | 
"okb" | 
"opensea" | 
"osp-credential" | 
"pause" | 
"pills" | 
"plane" | 
"portrait" | 
"redo" | 
"refresh-dollar" | 
"restaurant" | 
"search_list" | 
"search_question" | 
"send" | 
"send2" | 
"shopping-bag" | 
"Telegram" | 
"TetherBadge" | 
"TikTok" | 
"transfer-in" | 
"transfer-out" | 
"TronBadge" | 
"twitter" | 
"Union" | 
"UnionPay" | 
"USDC" | 
"usdt" | 
"Visa" | 
"walletconnect";
 export const SvgNameMap = {"AgentAdvisor":1,
"AgentCompare":1,
"AgentFee":1,
"AgentFund":1,
"AgentHome":1,
"AgentPortfolio":1,
"AgentRanking":1,
"AgentSkill":1,
"Amex":1,
"Apple":1,
"arrow-top-right":1,
"ask":1,
"askEd":1,
"aura_solid":1,
"bank":1,
"BinanceBadge":1,
"BinanceUsdBadge":1,
"BitcoinBadge":1,
"bnb-member":1,
"Campaign":1,
"car":1,
"ChainlinkBadge":1,
"check-contained":1,
"Coinbase":1,
"coverage-radar-light":1,
"coverage-radar":1,
"dai":1,
"Diners Club":1,
"Discord":1,
"Discover":1,
"dollar-bag":1,
"dot":1,
"Earlybird":1,
"edgen-feed":1,
"empty-feed":1,
"empty-result":1,
"error-circle-portfolio-notice":1,
"error-circle-portfolio":1,
"error":1,
"eth-w":1,
"eth":1,
"EthereumBadge":1,
"film":1,
"flag":1,
"Gas":1,
"GasBnb":1,
"GasDapp":1,
"goal-16-portfolio":1,
"Google pay":1,
"Google with colour":1,
"gravity-ui_signal":1,
"growUp":1,
"heart":1,
"hot-outline":1,
"ic_base":1,
"ic_loading":1,
"ic_loading2":1,
"icon-first-read":1,
"icon-goallive":1,
"Instagram":1,
"JCB":1,
"leaderboard":1,
"manage":1,
"Mastercard":1,
"matic":1,
"member-01":1,
"member-02-b":1,
"member-02-o":1,
"member-03-b":1,
"member-03-p":1,
"member-04-b":1,
"member-04-p":1,
"member":1,
"Metamask":1,
"MetaMaskBadge":1,
"minus":1,
"okb":1,
"opensea":1,
"osp-credential":1,
"pause":1,
"pills":1,
"plane":1,
"portrait":1,
"redo":1,
"refresh-dollar":1,
"restaurant":1,
"search_list":1,
"search_question":1,
"send":1,
"send2":1,
"shopping-bag":1,
"Telegram":1,
"TetherBadge":1,
"TikTok":1,
"transfer-in":1,
"transfer-out":1,
"TronBadge":1,
"twitter":1,
"Union":1,
"UnionPay":1,
"USDC":1,
"usdt":1,
"Visa":1,
"walletconnect":1,
}